import { List } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import * as coreApi from "api/Core";
import { FilterBarStyleClasses, GlobalSearchStyleClasses } from "assets/jss/common-styles";
import { AppMessageBox } from "components/AppMessageBox";
import { SpinnerIndicator } from "components/CallServer";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiPagination from "components/MuiExtras/MuiPagination";
import MuiPaper from "components/MuiExtras/MuiPaper";
import { GlobalSearchRecord } from "models/ApiModels";
import queryString from 'query-string';
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { GlobalSearchRowsPerPage } from "views/Search/FullGlobalSearch";
import { SearchRenderTopic } from "./Components/SearchRenderTopic";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    loading: boolean;
    searchResult: GlobalSearchRecord;
    recordsLoaded: number;
    lastOffset: number;
    lastError: any;
}

interface IProps {
}

type Props = IProps & RouteComponentProps<{}> & WithStyles<typeof FilterBarStyleClasses> & WithStyles<typeof GlobalSearchStyleClasses>;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export class FullTopicSearch extends React.Component<Props, IState> {
    private searchText: string;

    constructor(props: Props) {
        super(props);
        this.state = {
            searchResult: null,
            recordsLoaded: 0,
            lastOffset: 0,
            loading: true,
            lastError: null
        };
    }

    private loadData(offset: number) {
        this.setState({
            loading: true,
            lastError: null
        });

        coreApi.globalSearchTopics(this.searchText, offset, GlobalSearchRowsPerPage)
            .then((result) => {
                this.setState({
                    loading: false,
                    searchResult: result,
                    lastOffset: offset
                });
            })
            .catch((lastError) => {
                this.setState({ lastError: lastError.message || lastError, loading: false });
            });
    }

    private reset(p: Props) {
        const values = queryString.parse(p.location.search);
        this.searchText = values.q as string;
        this.loadData(0);
    }


    public componentDidMount() {
        this.reset(this.props);
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.location.search != this.props.location.search)
            this.reset(this.props);
    }

    private renderSearch() {

        const { searchResult, lastOffset } = this.state;

        return (
            <MuiPaper paperColor="white" className={this.props.classes.topicCard}>
                <List>
                    {
                        searchResult.items.map((v, index) => {
                            return <SearchRenderTopic data={v} index={index} key={index} showDivider={false}  />;
                        })
                    }
                </List>
                {
                    searchResult.totalRecords > GlobalSearchRowsPerPage &&
                    <MuiPagination
                        limit={GlobalSearchRowsPerPage}
                        offset={lastOffset}
                        total={searchResult.totalRecords}
                        onClick={(e, offset) => this.loadData(offset)}
                    />
                }
            </MuiPaper>
        );
    }

    public render() {
        const { lastError, loading, searchResult } = this.state;

        if (lastError != null)
            return <MuiMessageBox variant="error" message={lastError} />;

        if (loading) return <SpinnerIndicator />;

        if (searchResult.totalRecords == 0)
            return <AppMessageBox variant="info" resource="TopicListEmpty" />;

        return this.renderSearch();
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////

const withAllStyles = withStyles(
    (theme) => ({
        ...FilterBarStyleClasses(theme),
        ...GlobalSearchStyleClasses(theme)
    }),
    { withTheme: true },
);

export default withAllStyles(FullTopicSearch);
